import carecentreTokens from "./tokens";

/**
 * Flat Zen editorial palette — a convenience re-export of the design tokens'
 * colour scale for makeStyles files migrating off the legacy `glassColors`.
 *
 * Mapping guide (glass → zen):
 *   glassColors.glass.* / background.primary  → zenColors.bgCard (#FFFFFF, flat)
 *   glassColors.background.secondary/grouped  → zenColors.bgBone
 *   glassColors.label.primary                 → zenColors.textInk
 *   glassColors.label.secondary               → zenColors.textMuted
 *   glassColors.label.tertiary/quaternary     → zenColors.textQuiet
 *   glassColors.separator.*                   → zenColors.line / lineStrong
 *   glassColors.fill.*                         → zenColors.bgBone / primaryFaint
 *   glassColors.system.blue/green/red/orange/purple
 *     → zenColors.info / success / danger / warning / (kloe caring)
 */
export const zenColors = carecentreTokens.color;

export default zenColors;
